<app-search [name]="name"
            [formName]="formName"
            [(data)]="data"
            [apiController]="apiController"
            [views]="views"
            [keyFieldName]="keyFieldName"
            [toolbarItems]="toolbarItems"
            [gridSettings]="gridSettings"
            [includeAddButton]="false">

</app-search>


